import {Badge} from '@common-web/components/ui/badge';
import {categoryForAuditAction, type AuditActionCategory} from '@common/auditLog/actionCategories';

export const AUDIT_ENTITY_TYPES = [
  'GROUP',
  'MEMBER',
  'ACCOUNT',
  'INVOICE',
  'CARRIER_INVOICE',
  'PAYOUT_PERIOD',
  'AGENT',
  'USER',
  'GROUP_PLAN',
  'SYSTEM',
] as const;

const ENTITY_TYPE_LABELS: Record<string, string> = {
  GROUP: 'Group',
  MEMBER: 'Member',
  ACCOUNT: 'Account',
  INVOICE: 'Invoice',
  CARRIER_INVOICE: 'Carrier Invoice',
  PAYOUT_PERIOD: 'Payout Period',
  AGENT: 'Agent',
  USER: 'User',
  GROUP_PLAN: 'Group Plan',
  SYSTEM: 'System',
};

export function entityTypeLabel(type: string): string {
  return ENTITY_TYPE_LABELS[type] ?? type;
}

/** Humanize an `AuditAction` enum value, e.g. FIELD_UPDATED → "Field Updated". */
export function formatAuditAction(action: string): string {
  return action
    .toLowerCase()
    .split('_')
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(' ');
}

const CATEGORY_CLASSES: Record<AuditActionCategory, string> = {
  Eligibility: 'bg-brand-blue/10 text-brand-blue border-brand-blue/20',
  Notes: 'bg-amber/10 text-amber border-amber/20',
  Products: 'bg-purple-100 text-purple-700 border-purple-200',
  Commissions: 'bg-emerald/10 text-emerald border-emerald/20',
  Lifecycle: 'bg-indigo-100 text-indigo-700 border-indigo-200',
  Billing: 'bg-rose-100 text-rose-700 border-rose-200',
  Configuration: 'bg-slate-100 text-slate-700 border-slate-200',
  Other: 'bg-brand-gray/10 text-brand-gray border-brand-gray/20',
};

export function AuditActionBadge({action}: {action: string}) {
  const category = categoryForAuditAction(action);
  return (
    <Badge variant='outline' className={`font-medium ${CATEGORY_CLASSES[category]}`}>
      {formatAuditAction(action)}
    </Badge>
  );
}
